export default __webpack_public_path__ + "assets/models/fd52050d11052ebd21a2bece12d70b38.glb";